import { useState } from "react";

interface DaySchedule {
  day: string;
  open: string;
  close: string;
  closed?: boolean;
  note?: string;
}

interface WorkingHoursProps {
  restaurantId: string;
  restaurantName: string;
}

const hoursData: Record<string, DaySchedule[]> = {
  "ciya-sofrasi": [
    { day: "Pazartesi", open: "11:00", close: "22:00" },
    { day: "Salı", open: "11:00", close: "22:00" },
    { day: "Çarşamba", open: "11:00", close: "22:00" },
    { day: "Perşembe", open: "11:00", close: "22:00" },
    { day: "Cuma", open: "11:00", close: "22:00" },
    { day: "Cumartesi", open: "11:00", close: "22:30" },
    { day: "Pazar", open: "11:00", close: "21:00" },
  ],
  "mikla": [
    { day: "Pazartesi", open: "18:30", close: "00:00", note: "Sadece akşam" },
    { day: "Salı", open: "18:30", close: "00:00", note: "Sadece akşam" },
    { day: "Çarşamba", open: "18:30", close: "00:00", note: "Sadece akşam" },
    { day: "Perşembe", open: "18:30", close: "00:00", note: "Sadece akşam" },
    { day: "Cuma", open: "18:30", close: "01:00", note: "Sadece akşam" },
    { day: "Cumartesi", open: "18:30", close: "01:00", note: "Sadece akşam" },
    { day: "Pazar", closed: true, open: "", close: "" },
  ],
  "imam-cagdas": [
    { day: "Pazartesi", open: "07:00", close: "22:00" },
    { day: "Salı", open: "07:00", close: "22:00" },
    { day: "Çarşamba", open: "07:00", close: "22:00" },
    { day: "Perşembe", open: "07:00", close: "22:00" },
    { day: "Cuma", open: "07:00", close: "22:00" },
    { day: "Cumartesi", open: "07:00", close: "23:00" },
    { day: "Pazar", open: "08:00", close: "21:00" },
  ],
  "borsam-tasievi": [
    { day: "Pazartesi", open: "12:00", close: "22:00" },
    { day: "Salı", open: "12:00", close: "22:00" },
    { day: "Çarşamba", open: "12:00", close: "22:00" },
    { day: "Perşembe", open: "12:00", close: "22:00" },
    { day: "Cuma", open: "12:00", close: "23:00" },
    { day: "Cumartesi", open: "11:00", close: "23:00" },
    { day: "Pazar", open: "11:00", close: "22:00" },
  ],
  "hatay-sultan-sofrasi": [
    { day: "Pazartesi", open: "09:00", close: "22:00" },
    { day: "Salı", open: "09:00", close: "22:00" },
    { day: "Çarşamba", open: "09:00", close: "22:00" },
    { day: "Perşembe", open: "09:00", close: "22:00" },
    { day: "Cuma", open: "09:00", close: "23:00" },
    { day: "Cumartesi", open: "09:00", close: "23:00" },
    { day: "Pazar", open: "10:00", close: "21:00" },
  ],
  "karadeniz-pidecisi": [
    { day: "Pazartesi", open: "06:30", close: "20:00" },
    { day: "Salı", open: "06:30", close: "20:00" },
    { day: "Çarşamba", open: "06:30", close: "20:00" },
    { day: "Perşembe", open: "06:30", close: "20:00" },
    { day: "Cuma", open: "06:30", close: "20:00" },
    { day: "Cumartesi", open: "06:30", close: "21:00" },
    { day: "Pazar", open: "07:00", close: "19:00" },
  ],
  "rize-serender": [
    { day: "Pazartesi", open: "09:00", close: "20:00" },
    { day: "Salı", open: "09:00", close: "20:00" },
    { day: "Çarşamba", open: "09:00", close: "20:00" },
    { day: "Perşembe", open: "09:00", close: "20:00" },
    { day: "Cuma", open: "09:00", close: "20:00" },
    { day: "Cumartesi", open: "09:00", close: "21:00" },
    { day: "Pazar", open: "09:00", close: "20:00" },
  ],
  "trabzon-cemilusta": [
    { day: "Pazartesi", open: "06:00", close: "19:00" },
    { day: "Salı", open: "06:00", close: "19:00" },
    { day: "Çarşamba", open: "06:00", close: "19:00" },
    { day: "Perşembe", open: "06:00", close: "19:00" },
    { day: "Cuma", open: "06:00", close: "19:00" },
    { day: "Cumartesi", open: "06:00", close: "20:00" },
    { day: "Pazar", closed: true, open: "", close: "" },
  ],
  "assk-kahve": [
    { day: "Pazartesi", closed: true, open: "", close: "" },
    { day: "Salı", open: "09:00", close: "18:00" },
    { day: "Çarşamba", open: "09:00", close: "18:00" },
    { day: "Perşembe", open: "09:00", close: "18:00" },
    { day: "Cuma", open: "09:00", close: "19:00" },
    { day: "Cumartesi", open: "08:30", close: "20:00", note: "Rezervasyon önerilir" },
    { day: "Pazar", open: "08:30", close: "19:00", note: "Rezervasyon önerilir" },
  ],
  "izmir-deniz": [
    { day: "Pazartesi", open: "12:00", close: "23:00" },
    { day: "Salı", open: "12:00", close: "23:00" },
    { day: "Çarşamba", open: "12:00", close: "23:00" },
    { day: "Perşembe", open: "12:00", close: "23:00" },
    { day: "Cuma", open: "12:00", close: "00:00" },
    { day: "Cumartesi", open: "11:00", close: "00:00" },
    { day: "Pazar", open: "11:00", close: "23:00" },
  ],
  "antalya-seraser": [
    { day: "Pazartesi", open: "19:00", close: "00:00", note: "Sadece akşam" },
    { day: "Salı", open: "19:00", close: "00:00", note: "Sadece akşam" },
    { day: "Çarşamba", open: "19:00", close: "00:00", note: "Sadece akşam" },
    { day: "Perşembe", open: "19:00", close: "00:00", note: "Sadece akşam" },
    { day: "Cuma", open: "19:00", close: "01:00", note: "Sadece akşam" },
    { day: "Cumartesi", open: "19:00", close: "01:00", note: "Sadece akşam" },
    { day: "Pazar", closed: true, open: "", close: "" },
  ],
  "alanya-iskele": [
    { day: "Pazartesi", open: "11:00", close: "23:00" },
    { day: "Salı", open: "11:00", close: "23:00" },
    { day: "Çarşamba", open: "11:00", close: "23:00" },
    { day: "Perşembe", open: "11:00", close: "23:00" },
    { day: "Cuma", open: "11:00", close: "00:00" },
    { day: "Cumartesi", open: "10:00", close: "00:00" },
    { day: "Pazar", open: "10:00", close: "23:00" },
  ],
  "safranbolu-havuzlu": [
    { day: "Pazartesi", open: "08:00", close: "21:00" },
    { day: "Salı", open: "08:00", close: "21:00" },
    { day: "Çarşamba", open: "08:00", close: "21:00" },
    { day: "Perşembe", open: "08:00", close: "21:00" },
    { day: "Cuma", open: "08:00", close: "22:00" },
    { day: "Cumartesi", open: "07:30", close: "22:00" },
    { day: "Pazar", open: "07:30", close: "21:00" },
  ],
  "bolu-abant": [
    { day: "Pazartesi", open: "09:00", close: "20:00" },
    { day: "Salı", open: "09:00", close: "20:00" },
    { day: "Çarşamba", open: "09:00", close: "20:00" },
    { day: "Perşembe", open: "09:00", close: "20:00" },
    { day: "Cuma", open: "09:00", close: "21:00" },
    { day: "Cumartesi", open: "08:00", close: "21:00" },
    { day: "Pazar", open: "08:00", close: "20:00" },
  ],
  "konya-sifa": [
    { day: "Pazartesi", open: "10:00", close: "22:00" },
    { day: "Salı", open: "10:00", close: "22:00" },
    { day: "Çarşamba", open: "10:00", close: "22:00" },
    { day: "Perşembe", open: "10:00", close: "22:00" },
    { day: "Cuma", open: "10:00", close: "22:00" },
    { day: "Cumartesi", open: "10:00", close: "23:00" },
    { day: "Pazar", open: "11:00", close: "21:00" },
  ],
  "ankara-kizilirmak": [
    { day: "Pazartesi", open: "11:00", close: "22:00" },
    { day: "Salı", open: "11:00", close: "22:00" },
    { day: "Çarşamba", open: "11:00", close: "22:00" },
    { day: "Perşembe", open: "11:00", close: "22:00" },
    { day: "Cuma", open: "11:00", close: "23:00" },
    { day: "Cumartesi", open: "11:00", close: "23:00" },
    { day: "Pazar", open: "12:00", close: "21:00" },
  ],
};

const defaultHours: DaySchedule[] = [
  { day: "Pazartesi", open: "11:00", close: "22:00" },
  { day: "Salı", open: "11:00", close: "22:00" },
  { day: "Çarşamba", open: "11:00", close: "22:00" },
  { day: "Perşembe", open: "11:00", close: "22:00" },
  { day: "Cuma", open: "11:00", close: "23:00" },
  { day: "Cumartesi", open: "11:00", close: "23:00" },
  { day: "Pazar", open: "12:00", close: "21:00" },
];

const dayIndexMap: Record<string, number> = {
  "Pazar": 0, "Pazartesi": 1, "Salı": 2, "Çarşamba": 3,
  "Perşembe": 4, "Cuma": 5, "Cumartesi": 6,
};

const getCurrentDayName = (): string => {
  const days = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
  return days[new Date().getDay()];
};

const getCurrentTimeMinutes = (): number => {
  const now = new Date();
  return now.getHours() * 60 + now.getMinutes();
};

const timeToMinutes = (t: string): number => {
  if (!t) return 0;
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

const isCurrentlyOpen = (schedule: DaySchedule): boolean => {
  if (schedule.closed) return false;
  const now = getCurrentTimeMinutes();
  const open = timeToMinutes(schedule.open);
  let close = timeToMinutes(schedule.close);
  if (close === 0) close = 24 * 60; // midnight
  return now >= open && now < close;
};

const WorkingHours = ({ restaurantId }: WorkingHoursProps) => {
  const [expanded, setExpanded] = useState(false);
  const schedule = hoursData[restaurantId] || defaultHours;
  const todayName = getCurrentDayName();
  const todaySchedule = schedule.find((s) => s.day === todayName);
  const isOpen = todaySchedule ? isCurrentlyOpen(todaySchedule) : false;

  return (
    <div className="mt-14">
      <h2
        className="text-xl font-bold text-stone-900 mb-5"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        Çalışma Saatleri
      </h2>

      {/* Status + Today summary */}
      <div
        className="flex items-center justify-between p-4 bg-stone-50 rounded-2xl border border-stone-100 cursor-pointer hover:bg-stone-100 transition-colors"
        onClick={() => setExpanded((v) => !v)}
      >
        <div className="flex items-center gap-3">
          <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${isOpen ? "bg-emerald-500" : "bg-rose-400"}`}
            style={isOpen ? { boxShadow: "0 0 0 3px rgba(16,185,129,0.2)" } : {}}
          />
          <div>
            <span className={`text-sm font-semibold ${isOpen ? "text-emerald-700" : "text-rose-600"}`}>
              {isOpen ? "Şu an açık" : "Şu an kapalı"}
            </span>
            {todaySchedule && !todaySchedule.closed && (
              <span className="text-stone-500 text-sm ml-2">
                · Bugün {todaySchedule.open} – {todaySchedule.close === "00:00" ? "gece yarısı" : todaySchedule.close}
              </span>
            )}
            {todaySchedule?.closed && (
              <span className="text-stone-500 text-sm ml-2">· Bugün kapalı</span>
            )}
          </div>
        </div>
        <div className="w-6 h-6 flex items-center justify-center text-stone-400">
          {expanded
            ? <i className="ri-arrow-up-s-line text-lg"></i>
            : <i className="ri-arrow-down-s-line text-lg"></i>
          }
        </div>
      </div>

      {/* Full schedule */}
      {expanded && (
        <div className="mt-3 rounded-2xl border border-stone-100 overflow-hidden">
          {schedule.map((item, idx) => {
            const isToday = item.day === todayName;
            const open = !item.closed && isCurrentlyOpen(item);
            return (
              <div
                key={item.day}
                className={`flex items-center justify-between px-5 py-3.5 ${
                  isToday ? "bg-amber-50" : idx % 2 === 0 ? "bg-white" : "bg-stone-50/50"
                } ${idx < schedule.length - 1 ? "border-b border-stone-100" : ""}`}
              >
                <div className="flex items-center gap-3">
                  {isToday && (
                    <div className={`w-2 h-2 rounded-full flex-shrink-0 ${open ? "bg-emerald-500" : "bg-rose-400"}`} />
                  )}
                  <span className={`text-sm ${isToday ? "font-bold text-stone-900" : "text-stone-600"}`}>
                    {item.day}
                    {isToday && (
                      <span className="ml-2 text-xs font-normal text-amber-600 bg-amber-100 px-1.5 py-0.5 rounded-full">
                        Bugün
                      </span>
                    )}
                  </span>
                </div>

                <div className="flex items-center gap-2">
                  {item.note && (
                    <span className="text-xs text-stone-400 italic hidden sm:inline">{item.note}</span>
                  )}
                  {item.closed ? (
                    <span className="text-sm text-rose-500 font-medium">Kapalı</span>
                  ) : (
                    <span className={`text-sm font-medium ${isToday ? "text-amber-700" : "text-stone-700"}`}>
                      {item.open} – {item.close === "00:00" ? "00:00" : item.close}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
          <div className="px-5 py-3 bg-stone-50 border-t border-stone-100">
            <p className="text-xs text-stone-400 italic">
              * Çalışma saatleri tatil ve özel günlerde değişebilir. Güncel bilgi için restoranı arayınız.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkingHours;
